import i18n from '@/lib/i18n'

export const CART_TITLE = i18n.t('cart.item.title')
export const SHIPPING_ADDRESS_TITLE = i18n.t('cart.shipping.addressInfo')

export const CART_FIELDS = {
  regularDeliveryDate: i18n.t('cart.date.regular'),
  desiredDeliveryDate: i18n.t('cart.date.title'),
}
